export default __webpack_public_path__ + "static/portfolio-21-c205966c210e82b3af7dc3dd93295699.jpg";